import { render } from "./secondePaire.vue?vue&type=template&id=b19700c0&scoped=true"
import script from "./secondePaire.vue?vue&type=script&lang=js"
export * from "./secondePaire.vue?vue&type=script&lang=js"

import "./secondePaire.vue?vue&type=style&index=0&id=b19700c0&lang=scss&scoped=true"

import exportComponent from "/usr/src/test-oho-sales/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b19700c0"]])

export default __exports__